import api from '@/apis'

export default {
  state: {
    record_btn_disable: false,
    tasks: [
      { name: 'Transcribe', value: 'transcribe' },
      { name: 'Translate to English', value: 'translate' }
    ],
    languages: [
      { name: 'Cantonese', value: 'zh-hk' },
      { name: 'Mandarin', value: 'zh' },
      { name: 'English', value: 'en' }
    ]
  },
  mutations: {
    SET_ASR_CARD_RECORD_BTN_DISABLE(state, payload) {
      state.record_btn_disable = payload
    }
  },
  actions: {
    async fetchSpeechRecognitionResult({ commit }, payload) {
      try {
        commit('SET_ASR_CARD_RECORD_BTN_DISABLE', true)
        commit('SET_ASR_RESULT_CARD_VISIBILITY', false)
        commit('SET_SNACKBAR', { status: true, color: 'loading', text: 'Converting...', loading: true })
        const response = await api.convertASR(payload)
        if (response.data.success) {
          commit('SET_ASR_RESULT_CARD_RESULTS', { audio_src: payload.url, asr_result: response.data.data })
          commit('SET_ASR_RESULT_CARD_VISIBILITY', true)
          commit('SET_SNACKBAR', { status: true, color: 'success', text: response.data.message, icon: 'check', timeout: '2000' })
        } else throw Error(response.data.message)
      } catch (error) {
        commit('SET_SNACKBAR', { status: true, color: 'error', text: error.message, icon: 'close', timeout: '2000' })
      } finally {
        commit('SET_ASR_CARD_RECORD_BTN_DISABLE', false)
      }
    }
  }
}
